import html2pdf from 'html2pdf.js';

/** Render plain text (title + body) into an A4 PDF and trigger a browser download. */
export const downloadTextAsPdf = async (title: string, text: string): Promise<void> => {
  const container = document.createElement('div');
  container.style.fontFamily = 'Georgia, serif';
  container.style.fontSize = '12pt';
  container.style.lineHeight = '1.6';
  container.style.color = '#000';

  const heading = document.createElement('h2');
  heading.textContent = title;
  const body = document.createElement('div');
  body.style.whiteSpace = 'pre-wrap';
  body.textContent = text;
  container.append(heading, body);

  const filename = `${(title || 'document').replace(/[^a-zA-Z0-9_-]/g, '_')}.pdf`;
  await html2pdf()
    .set({
      margin: 15,
      filename,
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      pagebreak: { mode: ['css', 'legacy'] },
    } as any)
    .from(container)
    .save();
};
